let initialState = {
	loadOut: [],
};

const LoadOutReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'LOGOUT': {
			return initialState;
		}
		case 'SET_LOAD_OUT':
			return {
				...state,
				loadOut: action.payload,
			};
		default:
			return state;
	}
};

export { LoadOutReducer };
